export default "__VITE_ASSET__DG9Ja4g0__"